import { isU128 } from '@morfi/market-math';

export function isPositiveRewardAmount(value: string | undefined): boolean {
  if (value === undefined || !/^(?:0|[1-9]\d*)$/.test(value)) return false;
  const amount = BigInt(value);
  return amount > BigInt(0) && isU128(amount);
}
